import React, { useMemo } from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import moment from "moment";

const LikeChart = ({ postsData, likesData }) => {
  const data = useMemo(() => {
    const months = [];
    for (let i = 3; i >= 0; i--) {
      months.push(moment().subtract(i, "months").format("MMM"));
    }

    const likesArray = Object.values(likesData);
    const likesByMonth = months.reduce((acc, m) => ({ ...acc, [m]: 0 }), {});

    Object.values(postsData).forEach((post) => {
      const month = moment(post?.createdAt).format("MMM");
      if (!(month in likesByMonth)) return;

      const postLikes = likesArray
        .filter((like) => like?.postId === post?.id)
        .reduce((sum, like) => sum + like.like, 0);

      likesByMonth[month] += postLikes;
    });

    return months.map((month) => ({ month, likes: likesByMonth[month] }));
  }, [postsData, likesData]);

  return (
    <div className="chart">
      <ResponsiveContainer width="100%" height={260}>
        <AreaChart
          data={data}
          margin={{ top: 10, right: 16, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="likesGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#f59e0b" stopOpacity={0.45} />
              <stop offset="95%" stopColor="#f59e0b" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid
            strokeDasharray="3 3"
            vertical={false}
            stroke="#404040"
          />
          <XAxis
            dataKey="month"
            tick={{ fill: "#9ca3af", fontSize: 12 }}
            tickLine={false}
            axisLine={{ stroke: "#404040" }}
          />
          <YAxis
            tick={{ fill: "#9ca3af", fontSize: 12 }}
            tickLine={false}
            axisLine={false}
            allowDecimals={false}
            width={36}
          />
          <Tooltip
            cursor={{ stroke: "#f59e0b", strokeWidth: 1, strokeDasharray: "4 4" }}
            contentStyle={{
              backgroundColor: "#1f2937",
              borderRadius: "8px",
              border: "none",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.5)",
              color: "#fff",
            }}
          />
          <Area
            type="monotone"
            dataKey="likes"
            name="Likes"
            stroke="#f59e0b"
            strokeWidth={3}
            fill="url(#likesGradient)"
            dot={{ r: 4, strokeWidth: 2, fill: "#1f2937", stroke: "#f59e0b" }}
            activeDot={{ r: 6 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LikeChart;
